// extracted by mini-css-extract-plugin
module.exports = {"label":"SortableHead__label--2v2MR","icon":"SortableHead__icon--2dYJY","asc":"SortableHead__asc--1qOjf"};